import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { StackColorEditComponent } from './stack-color-edit/stack-color-edit.component';

@Component({
  selector: 'app-stack-color',
  templateUrl: './stack-color.component.html',
  styleUrls: ['./stack-color.component.scss']
})
export class StackColorComponent implements OnInit {
  tableDef = {
    title: 'Stack Layer Color',
    tableName: 'framenames',
    pagedOn: true,
    filterOn: true,
    sortOn: true,
    fields: [
      {
        name: "id",
        label: "Id",
        type: "string",
        width: "55px",
        readonly: true
      },
      {
        name: "name",
        label: "Stack Layer",
        type: "string",
        width: "200px",
        readonly: true
      },
      {
        name: "color",
        label: "Color",
        type: "string",
        required: true,
        validateColor: true
      }
    ]
  };

  isData: boolean = true;
  data = [];
  loading = false;
  selectedRow = null;

  constructor(private http: HttpClient, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.loading = false;
    this.data = [];
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.http.get(`/api/data/${this.tableDef.tableName}`).subscribe((res: any) => {
      this.loading = false;
      this.data = res;
    }, (err: any) => {
      console.log('unable to get data');
      console.log(err);
    });
  }

  updateData(data) {
    this.loading = true;

    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x, data[x]);
    });

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post(`/api/data/${this.tableDef.tableName}`, body.toString(), { headers: headers }).subscribe((res: any) => {
      if (res.success) {
        const rtndata = res['data'][0];
        const rtnid = rtndata['id'];
        this.data.forEach((x, i) => {
          if (x['id'] === rtnid) {
            this.data[i] = rtndata;
          }
        });
        this.loading = false;
      }
    }, (error: any) => {
      console.log('Unable to update the table');
      this.loading = false;
    });
  }

  selectRow(id) {
    this.selectedRow = id;
  }

  editTable(id) {
    // find the data row and pass to the edit    
    this.selectedRow = id;
    const d = this.data.filter(x => x.id === this.selectedRow);
    if (d.length === 1) {
      this.openTableEdit(d[0]);
    }
  }

  openTableEdit(data) {
    const newData = this.deepCopy(data);
    const tableEdit = {
      tableDef: this.tableDef,
      data: newData
    };

    const dialogRef = this.dialog.open(StackColorEditComponent, {
      height: '320px',
      width: '400px',
      data: tableEdit
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== 'cancel') {
        this.updateData(result);
      }
    })
  }

  // deep copy of Object
  private deepCopy(obj) {
    return Object.keys(obj).reduce((v, d) => Object.assign(v, {
      [d]: obj[d] == null ? null : (obj[d].constructor === Object) ? this.deepCopy(obj[d]) : obj[d]
    }), {});
  }
}
